export default {
  to: "/settings/profile",
  order: 4,
  icon: "mdi-cog",
  title: "Settings",
  name: "SettingLinks",
  disabled: false,
  sublinks: [
    {
      to: "/settings/account-settings",
      icon: "mdi-account",
      title: "My Account",
      disabled: false,
      value: 0,
    },
    // {
    //   to: "/dashboard/settings/support",
    //   icon: "mdi-help-circle",
    //   title: "Help",
    //   disabled: true,
    //   value: 0,
    // },
  ],
};
